import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL!;

export const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

let hasTriggeredUnauthorized = false;

export const handleUnauthorized = () => {
    if (hasTriggeredUnauthorized) return;
    hasTriggeredUnauthorized = true;

    localStorage.removeItem('token');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('username');
    localStorage.removeItem('password');
    localStorage.removeItem('rememberMe');

    if (window.location.pathname !== '/login') {
        window.location.assign('/login');
    }
};

apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            handleUnauthorized();
        }
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            handleUnauthorized();
        }
        return Promise.reject(error);
    }
);
